function dateTimeService(date) {
    return {
        utcMinutes() {
            const hours = date.getUTCHours();
            const minutes = date.getUTCMinutes();

            return (hours * 60) + minutes;
        }
    }
}

export default dateTimeService;